import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@app/shared/shared.module';

import {
    AtomRequestsComponent,
    TransportRequestsTableComponent,
    LineRequestsComponent,
    TransportationRequestsComponent,
    TransportDetailsModelComponent
} from '@app/roles/milkrun-operator/pages/transportation-requests';
import { DateAgoPipe } from '@app/shared/pipes/date-ago.pipe';

@NgModule({
    declarations: [
        TransportationRequestsComponent,
        LineRequestsComponent,
        AtomRequestsComponent,
        TransportRequestsTableComponent,
        TransportDetailsModelComponent,
        DateAgoPipe
    ],
    imports: [
        CommonModule,
        SharedModule,
    ],
    providers: [],
    bootstrap: []
})
export class MilkrunOperatorModule {
}
